// extracted by mini-css-extract-plugin
module.exports = {"group":"ResourceFilterAndBannerWrapper_group__5WmZF","groupHasFilters":"ResourceFilterAndBannerWrapper_groupHasFilters__sZkNT"};